module.exports = __webpack_public_path__ + "fonts/icomoon.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/icomoon.woff
// module id = ./node_modules/@ps/common-core/dist/fonts/icomoon.woff
// module chunks = 1